// Validates required Vite env vars at startup so missing config fails loudly.
function required(name: string): string {
  const value = import.meta.env[name];
  if (typeof value !== 'string' || value.length === 0) {
    throw new Error(`Missing env var: ${name} (see web/.env.example)`);
  }
  return value;
}

const optional = (name: string): string | undefined => {
  const value = import.meta.env[name];
  return typeof value === 'string' && value.length > 0 ? value : undefined;
};

export const env = {
  firebase: {
    apiKey: required('VITE_FIREBASE_API_KEY'),
    authDomain: required('VITE_FIREBASE_AUTH_DOMAIN'),
    projectId: required('VITE_FIREBASE_PROJECT_ID'),
    storageBucket: required('VITE_FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: required('VITE_FIREBASE_MESSAGING_SENDER_ID'),
    appId: required('VITE_FIREBASE_APP_ID'),
    measurementId: optional('VITE_FIREBASE_MEASUREMENT_ID'),
  },
};
